export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-logo-0a4890191a2ffacc3b48d8f8853afd02.png";